// Transfer functions (§6.1). sRGB and Display P3 share the sRGB curve.
import type { ColorSpaceId } from './matrix';

export const srgbToLinear = (c: number) => (c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4));
export const linearToSrgb = (l: number) =>
  l <= 0.0031308 ? 12.92 * l : 1.055 * Math.pow(l, 1 / 2.4) - 0.055;

export const ADOBE_GAMMA = 563 / 256;
export const adobeToLinear = (c: number) => Math.pow(Math.max(c, 0), ADOBE_GAMMA);
export const linearToAdobe = (l: number) => Math.pow(Math.max(l, 0), 1 / ADOBE_GAMMA);

/** Sign-preserving versions for out-of-gamut working values. */
export const encodeSigned = (l: number) => Math.sign(l) * linearToSrgb(Math.abs(l));
export const decodeSigned = (c: number) => Math.sign(c) * srgbToLinear(Math.abs(c));

export function encoder(space: ColorSpaceId): (l: number) => number {
  return space === 'adobergb' ? linearToAdobe : (l) => linearToSrgb(Math.max(l, 0));
}
export function decoder(space: ColorSpaceId): (c: number) => number {
  return space === 'adobergb' ? adobeToLinear : srgbToLinear;
}
